import Actions             from 'Redux/Actions';
import { AppUserRepository } from 'Domain/Repositories';
import { ofType }          from 'redux-observable';
import { from }            from 'rxjs';
import { mergeMap }        from 'rxjs/operators';
import { TEpic }           from 'Redux/Config';

export const findAppUsersEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findAppUsersRequest.type),
    mergeMap(action => from(
      AppUserRepository.findAll(action.payload)
        .then(({ appUsers, meta }) => Actions.findAppUsersSuccess({ appUsers, maxCount: meta?.count }))
        .catch((error: Error) => Actions.findAppUsersFailure({ error })),
    )),
  );
};
